import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=18381e58&scoped=true&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=18381e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18381e58",
  null
  
)

export default component.exports